import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from "../../../store/actions";
import { i18n } from '../../../translate/i18n';
import {
  Container, Paper, Typography, IconButton, Divider, List, ListItem, ListItemText, Dialog, Tooltip,
  Box,
} from '@mui/material';

import { AddCircle, FileCopyTwoTone } from '@mui/icons-material';
import { sortBy } from 'lodash';

import Spinner from '../../../components/Spinner/index';
import hasSiteAccess from '../../../utils/hasSiteAccess';
import SiteSelector from '../../../UI/SiteSelector/SiteSelector';

import ModalEquipmentServices from '../Modals/ModalEquipmentServices';
import ModalCloneChecklist from '../Modals/ModalCloneChecklist';
import ModalCloneChecklistSite from '../Modals/ModalCloneChecklistSite';

const FormParamEquipments = (props) => {
  const dispatch = useDispatch();

  const [openModal, setOpenModal] = useState(false);
  const [openModalCloneChecklist, setOpenModalCloneChecklist] = useState(false);
  const [openModalCloneChecklistSite, setOpenModalCloneChecklistSite] = useState(false);
  const [modalContent, setModalContent] = useState();
  const [active, setActive] = useState(false);

  //get from redux
  const equipmentModel = useSelector(state => state.equipmentModels.equipmentModel);
  const loading = useSelector(state => state.equipmentModels.loading);

  const selectedSites = useSelector(state => state.sites.selectedSitesQuestions);
  const selectedAccess = useSelector(state => state.auth.selectedAccess);

  const handleClickInspection = (equipServices) => {
    if (selectedSites.length > 0) {
      setModalContent(equipServices);
      setOpenModal(true);
      setActive(equipServices.active);
    }
  }

  const handleClickAddService = () => {
    setModalContent();
    setOpenModal(true);
  }

  const handleCloseModal = () => {
    setModalContent();
    setOpenModal(false);
  }

  const selectSite = useCallback(
    (site) => dispatch(actions.selectSiteQuestions(site))
  );
	
	const handleClickCloneChecklist = (event, equipServices) => {
		event.stopPropagation();

		setModalContent(equipServices);
		setOpenModalCloneChecklist(true);
	}

	const handleCloseCloneChecklist = () => {
		setModalContent();
    setOpenModalCloneChecklist(false);
	}

	const handleClickCloneChecklistSite = () => {
		setOpenModalCloneChecklistSite(true);
	}

	const handleCloseCloneChecklistSite = () => {
		setModalContent();
		setOpenModalCloneChecklistSite(false);
	}

  return <>
    <Container maxWidth='sm' style={styles.container}>
      <Paper style={styles.paper}>
        <div style={{ ...styles.titleContainer, opacity: loading ? '0.3' : '1' }}>
          <div style={styles.titleContent}>
            <Typography variant='h6'>{i18n.t('typographyFormParamEquipService.text')}</Typography>
            <IconButton onClick={handleClickCloneChecklistSite} size="large">
              <Tooltip title='clonar tipo de serviço'>
                <FileCopyTwoTone />
              </Tooltip>
            </IconButton>
          </div>
          <IconButton onClick={handleClickAddService} size="large">
            <Tooltip title='adicionar serviço'>
              <AddCircle />
            </Tooltip>
          </IconButton>
        </div>
        <Divider />
        <div style={{ marginTop: 10 }}>
          <SiteSelector selectedSites={selectedSites} selectSite={(site) => selectSite(site)} />
        </div>
        <List style={{ minHeight: 75, opacity: loading ? '0.3' : '1' }}>
          {loading && <Spinner overlay />}
          {equipmentModel && equipmentModel.equipmentServices && sortBy([...equipmentModel.equipmentServices.map(equipService => ({ ...equipService, active: true })), ...equipmentModel.inactiveEquipmentServices.map(Service => ({ ...Service, active: false }))], ['serviceType.name', 'frequency.name']).map((equipServices) => (
            <ListItem
              onClick={() => handleClickInspection(equipServices)}
              style={{...styles.listItem, backgroundColor: equipServices.active ? 'white' : 'rgba(0, 0, 0, 0.12)'}}
              key={equipServices._id}
              button
            >
              <ListItemText
                primary={
                  <div style={styles.listItemTextContainer}>
                    <Typography style={styles.listItemText}>
                      {`${equipServices.serviceType.name} / ${equipServices.frequency.name}`}
                    </Typography>
                    <div style={styles.listItemTextIconContainer}>
                      {selectedSites.length > 0 ?
                        <>
                          <div style={styles.checklistButton}>Checklist ({equipServices.questions.filter(question => question.type === 'question' && !question.deleted &&  question.site === selectedSites[0]._id).length})</div>
                          {!equipServices.active && <Box style={styles.inactiveChip}>{i18n.t('typographyFormParamEquipService.inactive')}</Box>}
                          {(hasSiteAccess(selectedAccess, selectedSites[0]._id) && equipServices.active) &&
                          <IconButton style={styles.iconButtonCopy} size='medium' onClick={(event) => handleClickCloneChecklist(event, equipServices)}><FileCopyTwoTone fontSize='small' /></IconButton>}
                        </>
                        : <Typography style={styles.listItemText}>{i18n.t('typographyFormParamEquipService.text1')}</Typography>}
                    </div>
                  </div>
                }
              />
            </ListItem>
          ))}
        </List>

      </Paper>
    </Container>

    <Dialog
      scroll='body'
      fullWidth
      maxWidth="md"
      open={openModal}
      onClose={handleCloseModal}
      PaperProps={{
        style: {
          overflow: 'visible'
        },
      }}
    >
      <ModalEquipmentServices
        closeModal={handleCloseModal}
        modalContent={modalContent}
        active={active}
      />
    </Dialog>

    <Dialog
      scroll='body'
      fullWidth
      open={openModalCloneChecklist}
      onClose={handleCloseCloneChecklist}
      PaperProps={{
        style: {
          overflow: 'visible'
        },
      }}
    >
      <ModalCloneChecklist
        closeModal={handleCloseCloneChecklist}
        modalContent={modalContent}
        equipmentModel={equipmentModel}
      />
    </Dialog>
          
    <Dialog
      scroll='body'
      fullWidth
      open={openModalCloneChecklistSite}
      onClose={handleCloseCloneChecklistSite}
      PaperProps={{
        style: {
          overflow: 'visible'
        },
      }}
    >
      <ModalCloneChecklistSite
        closeModal={handleCloseCloneChecklistSite}
        modalContent={modalContent}
        equipmentModel={equipmentModel}
      />
    </Dialog>

  </>;
}

export default FormParamEquipments;

const styles = {
  container: {
    padding: 10,
    margin: 0,
    marginLeft: 50,
    marginBottom: 50,
  },
  paper: {
    padding: '20px',
    position: 'relative',
  },
  checklistButton: {
    background: '#bbd2ca',
    border: 'none',
    fontSize: '0.875rem',
    fontWeight: 400,
    borderRadius: 15,
    padding: '5px 10px 5px 10px'
  },
  inactiveChip: {
    background: 'rgba(0, 0, 0, 0.08)',
    border: 'none',
    fontSize: '0.875rem',
    fontWeight: 400,
    borderRadius: 15,
    padding: '5px 10px 5px 10px',
    margin: '0 5px',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
	},
	titleContent: {
		display: 'flex',
		alignItems: 'center',
	},

  spinner: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    top: '-5px',
    opacity: '1',
    zIndex: 2,
  },

  listItem: {
    padding: 0,
    borderBottom: '1px solid #ccc'
  },
  listItemTextContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  listItemText: {
		fontSize: '0.9rem',
		padding: '1rem 0'
  },
  listItemTextIconContainer: {
    display: 'flex',
    alignItems: 'center',
	},
	iconButtonCopy: {
		margin: '0 0.25rem'
	},
	

}


